import { action } from '@ember/object';
import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { getOwner } from '@ember/application';

/**
*
This service is used to trigger opening and closing of the initiative slideover;
The Initiative slideover is a slideover that pops in and out from the right of the screen
with a pre-populated initiative form. It is populated based on the Initiative ID that it is provided with when triggering it open
*
*/
export default class InitiativeSlideoverService extends Service {
  @tracked isOpen;
  @tracked initiative;
  @tracked progressPanelIsOpen;
  @tracked updateWizardIsOpen;
  @service store;
  @service tracker;

  @action
  setInitiative(initiative_id) {
    const initiative = this.store.peekRecord('initiative', initiative_id);
    this.store.findRecord('initiative', initiative_id, {
      include: 'workstream',
    });
    this.initiative = initiative;
  }

  @action
  open(initiative_id) {
    this.setInitiative(initiative_id);
    this.isOpen = true;
    this.tracker.trackSlideoverOpenedEvent(initiative_id);
    this.applicationController.set('initiative_id', initiative_id);
  }

  get applicationController() {
    const owner = getOwner(this);
    const applicationRoute = owner.lookup('route:application');
    return applicationRoute.controller;
  }

  @action
  openProgressPanel(initiative_id) {
    this.setInitiative(initiative_id);
    this.progressPanelIsOpen = true;
    this.tracker.trackSlideoverOpenedEvent(initiative_id);
  }

  @action
  openWizard(initiative_id) {
    this.setInitiative(initiative_id);
    this.updateWizardIsOpen = true;
    this.tracker.trackInitiativeUpdateEvent(initiative_id);
  }

  @action
  closeWizard() {
    this.updateWizardIsOpen = false;
  }

  @action
  closeProgressPanel() {
    this.progressPanelIsOpen = false;

    /**
     * This time out here is so that the initiative object unsets itself only
     * after the slideover has popped back in,
     * the transition duration of which is 500ms
     */
    setTimeout(() => {
      this.initiative = null;
    }, 500);
  }

  @action
  close() {
    this.applicationController.set('initiative_id', undefined);
    this.isOpen = false;

    /**
     * This time out here is so that the initiative object unsets itself only
     * after the slideover has popped back in,
     * the transition duration of which is 500ms
     */
    setTimeout(() => {
      this.initiative = null;
    }, 500);
  }
}
